export var Gender;
(function (Gender) {
    Gender["Male"] = "Male";
    Gender["Female"] = "Female";
    Gender["Other"] = "Other";
})(Gender || (Gender = {}));
export function getGenderName(gender) {
    switch (gender) {
        case Gender.Male:
            return $t(`%XK`);
        case Gender.Female:
            return $t(`%XM`);
        default:
            return $t(`%1JG`);
    }
}
//# sourceMappingURL=Gender.js.map